var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-4 mt-8",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"mr-8 home-content",domProps:{"innerHTML":_vm._s(_vm.homeContent)}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }